import RoutesMap from '../../route_control/RouteControl'
// import { LuAlignJustify, KeyRound, Power, UserPen, UserCog, LuLanguages } from 'react-icons/lu'
import { ListCollapse, UserCog, UserPen, KeyRound, Power, MoveRight, Languages } from 'lucide-react'
import { useNavigate } from 'react-router'
import { Dropdown } from 'react-bootstrap'
import Logo from '../../assets/images/reexoasset.png'
// import { FlagIcon } from 'react-flag-kit'
import Select from 'react-select'
import { ConfigProvider, Select as Search } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { SessionManager } from '../../utils'
import { companyDetailsTodo } from '../../redux/slices/superAdmin/company/CompanyDetails'
import { grnStockListTodo } from '../../redux/slices/grn/stock/GrnStockList'

export const HeaderImport = {
    RoutesMap,
    SessionManager,
    // LuAlignJustify,
    // LuLanguages,
    ListCollapse,
    KeyRound,
    Power,
    UserPen,
    UserCog,
    useDispatch,
    MoveRight,
    Languages,
    useNavigate,
    Dropdown,
    Logo,
    // FlagIcon,
    ConfigProvider,
    Select,
    Search,
    useSelector,
    dayjs,
    useTranslation,
    companyDetailsTodo,
    grnStockListTodo
}